import { Button } from "@mui/material"
import React from "react"
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded"
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded"

interface Props {
  opened: boolean
  onShowMoreClick: () => void
  size?: 'small' | 'medium'
}

export const ShowMoreButton = ({ opened, onShowMoreClick, size }: Props) => {
  return (
    <Button
      disableRipple
      variant="text"
      size={size}
      onClick={onShowMoreClick}
      endIcon={opened ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}
      sx={{
        "&:hover": {
          backgroundColor: "transparent",
          boxShadow: "none"
        }
      }}
    >
      {opened ? "Show less info" : "Show more info"}
    </Button>
  )
}
